import { cn } from '@/lib/utils'
const DEFAULT_IMG = 'https://cdn.zhiyitech.cn/material/9d015338199d7b11a5a65d43322a2ff6'

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('bg-muted-foreground-3 flex items-center justify-center animate-pulse rounded-md', className)}
      {...props}
    >
      <img src={DEFAULT_IMG} alt="骨架屏展位图" className="w-20 h-20" />
    </div>
  )
}

export { Skeleton }
